import "twin.macro";

import { useParams } from "react-router";

import { CircularProgress } from "@mui/material";

import { Contained } from "@components/StyledComponents";
import { Title } from "@features/ui";

export const PurchaseOrderSkeleton = () => {
  const { poId } = useParams();
  return (
    <Contained>
      <Title backUrl={"/purchasing/purchase-order-history"}>
        Purchase Order #{poId}
      </Title>
      <CircularProgress />
    </Contained>
  );
};
